import * as React from 'react';
import {useLocation} from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import {BRAND} from '../brand';

// Shared shell for the plain-text policy pages (/privacy, /data-deletion, /terms). Meta's app
// settings link to these, so they must render without sign-in or GraphQL.
// Who "we" are comes from the brand (config/brands.yml).
export const LEGAL_ENTITY = BRAND.legal_entity;
export const LEGAL_ADDRESS = BRAND.legal_address;

interface Props {
    eyebrow: string;
    title: string;
    updated: string;
    children: React.ReactNode;
}

const LegalPage: React.FC<Props> = ({eyebrow, title, updated, children}) => {
    // Deep links like /terms#rentals: the router doesn't scroll to the anchor itself.
    const {hash} = useLocation();
    React.useEffect(() => {
        if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
    }, [hash]);

    return (
        <div className="bg-lumina-dark min-h-screen text-white">
            <Navbar/>
            <main className="max-w-3xl mx-auto px-6 pt-28 pb-24">
                <span className="text-lumina-purple font-display text-sm tracking-wider uppercase">{eyebrow}</span>
                <h1 className="text-4xl md:text-5xl font-display font-bold mt-2 mb-2">{title}</h1>
                <p className="text-gray-500 text-sm mb-10">Last updated {updated}</p>
                <div className="space-y-8 text-gray-300 leading-relaxed [&_h2]:text-white [&_h2]:text-xl [&_h2]:font-display [&_h2]:font-bold [&_h2]:mb-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_a]:text-lumina-accent">
                    {children}
                </div>
            </main>
            <Footer/>
        </div>
    );
};

export default LegalPage;
